export const runtimeActionTypes = {
  SET_RESOLVED_FORMULA_PARAMS: "runtime/SET_RESOLVED_FORMULA_PARAMS"
}

export const runtimeInitialState = {
  resolvedFormulaParamsByAddress: {}
}

export default (state = runtimeInitialState, action) => {
  switch (action.type) {
    case runtimeActionTypes.SET_RESOLVED_FORMULA_PARAMS:
      return {
        ...state,
        resolvedFormulaParamsByAddress: {
          ...state.resolvedFormulaParamsByAddress,
          [action.address]: {
            formulaType: action.formulaType,
            params: action.params
          }
        }
      }
    default:
      return state
  }
}
